const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrandQLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "35 30 400 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M87.13,101.93v9.35h-.44c-3.17-3.39-8.76-5.37-15.24-5.37s-10.16,2.65-10.16,6.77c0,3.46,2.58,5.23,10.82,6.04,13.03,1.33,17.82,5.82,17.82,14.8s-7.07,14.87-19.14,14.87c-8.03,0-14.36-1.62-18.33-4.64v-9.42h.44c4.42,4.05,10.53,6.18,17.67,6.18,6.77,0,10.6-2.43,10.6-6.77,0-3.75-2.65-5.52-11.34-6.48-12.74-1.4-17.3-5.52-17.3-14.06,0-9.42,7.29-15.17,19.07-15.17,6.41,0,12.37,1.55,15.54,3.9Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.07,147.66v-41.01h-15.39v-7.88h39.54v7.88h-15.31v41.01h-8.84Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65,147.66v-48.89h21.65c11.85,0,17.97,5.3,17.97,15.54,0,7.88-3.68,12.81-10.82,14.65l12.3,18.7h-10.46l-10.9-17.89h-10.9v17.89h-8.84ZM162,121.89c6.33,0,9.35-2.5,9.35-7.58s-3.02-7.66-9.35-7.66h-12.52v15.24h12.52Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,138.45h-25.03l-3.9,9.2h-9.2l21.5-48.89h8.47l21.57,48.89h-9.5l-3.9-9.2ZM210.74,108.78l-9.2,21.94h18.55l-9.2-21.94h-.15Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18,147.66l-24.08-39.24h-.15v39.24h-8.54v-48.89h12.15l22.6,36.52h.15v-36.52h8.54v48.89h-10.68Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.19,98.77c16.49,0,25.99,9.06,25.99,24.44s-9.5,24.44-25.99,24.44h-19.29v-48.89h19.29ZM316.75,139.78c11.26,0,17.52-5.96,17.52-16.57s-6.26-16.57-17.52-16.57h-10.01v33.13h10.01Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,142.64l8.32,10.6h-9.65l-5.23-6.7c-3.17,1.18-6.63,1.84-10.38,1.84-15.02,0-25.55-10.45-25.55-25.18s10.53-25.18,25.55-25.18,25.55,10.46,25.55,25.18c0,8.1-3.17,14.95-8.61,19.44ZM396.48,139.84l-8.61-11.04h9.64l5.6,7.14c3.09-3.02,4.86-7.51,4.86-12.74,0-10.23-6.77-17.3-16.64-17.3s-16.64,7.07-16.64,17.3,6.77,17.3,16.64,17.3c1.84,0,3.53-.22,5.15-.66Z",
    style: {
      fill: "#1f51f3",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrandQLogo);
export default __webpack_public_path__ + "static/media/strand-q-logo.4d40dda257b6d171e7addec3f9bc88f6.svg";
export { ForwardRef as ReactComponent };